export function isTestNetwork(network, chainId) {
    return Number(chainId) === 97 || Number(chainId) === 5 || /test/i.test(network?.shortname || '')
}
export function getNetworkDisplayName(network, chainId, t) {
    if (Number(chainId) === 97) return t('BNB Chain Testnet')
    if (isTestNetwork(network, chainId)) return `${network?.name || t('未知网络')} ${t('测试网')}`
    return network?.name || t('未知网络')
}
